const referencedProps = {
  cx: 0,
  cy: 0,
  // Distance to the start node
  g: Infinity,
  h: Infinity,
  f: Infinity,
  visited: false,
  parent: null,
  closed: false
};

export const allNodesInfo = dataArr => {
  let result = [];
  dataArr.forEach(item => {
    if (item) {
      result.push({
        id: item.id,
        ...referencedProps,
        visited: item.noRedirect,
        cx: item.cx,
        cy: item.cy
      });
    }
  });
  return result;
};

export default function matrixBuilder (dataArr, eleLength) {
  let maxId = 0;
  dataArr.forEach(item => {
    if (item[0] && item[1]) {
      maxId = Math.max(maxId, item[0].id, item[1].id);
    }
  });
  const actualLength = Math.max(eleLength || 0, maxId + 1);

  const arrayModel = new Array(actualLength);

  let result = [...arrayModel].fill([...arrayModel].fill(Infinity));
  dataArr.forEach(item => {
    const xAxis = item[0].id;
    const yAxis = item[1].id;
    const distance = item[2];
    let newXAxis = [...result[xAxis]];
    newXAxis.splice(yAxis, 1, distance);
    result[xAxis] = newXAxis;

    const newXAxis2 = [...result[yAxis]];
    newXAxis2.splice(xAxis, 1, distance);
    result[yAxis] = newXAxis2;

  });
  return result;
};